import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from '@hunchads/header';
import { AccountService, CatalogsHubService, get, set } from '@shared';

window.UIkit = UIkit;

import UIkit from 'uikit';
declare global {
  interface Window {
    UIkit: any;
    user: any;
  }
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'automation-plan';
  private hub: CatalogsHubService = inject(CatalogsHubService);
  private accountService: AccountService = inject(AccountService);



  ngOnInit(): void {
    this.hub.listenHubSubscriptions();

    setTimeout(() => {
      const allowProducts = JSON.parse(get("allowProducts"));
      const allowInsights = JSON.parse(get('allowInsights'));
      const header = new Header({
        container: document.getElementById('header-container')!,
        accounts: get("accounts"),
        selectedUser: get("user"),
        defaultLink: 'data-automationplans="true"',
        urls: {
          hunchManageAppUrl:(allowInsights.length === 0 || allowInsights.includes(get('user')?.teamId) || get('user')?.teamId > 885) ? get('hunchInsightsAppUrl') : get('hunchManageAppUrl'),
          hunchCatalogsAppUrl: get('hunchCatalogsAppUrl'),
          hunchAppUrl: get("hunchAppUrl"),
          hunchAutomationPlansUrl: get("hunchAutomationPlansUrl"),
          hunchLibraryAppUrl: get("hunchLibraryAppUrl"),
          hunchProductsAppUrl: get("hunchProductsAppUrl"),
          hunchSettingsAppUrl: get("hunchSettingsAppUrl")
        },
        itemsForHide: allowProducts.length > 0 && !allowProducts.includes(get('user')?.teamId) ? ['data-products="true"'] : [],
        onAccountChange: (accountId: any) => {
          set("user", { ...get('user'), accountId });
          this.accountService.accountChanged.next(accountId);
          if (window.location.pathname !== '/') {
            window.location.href = get("hunchAutomationPlansUrl");
          }
        },
        onLogout: () => {
          console.log('Logout clicked');
        }
      });
    }, 0);
  }
  accountChanged(user: any): void {
    set('user', user);
    this.accountService.accountChanged.next(user.accountId);
    if (window.location.pathname !== '/') {
      window.location.href = get("hunchAutomationPlansUrl");
    }
  }
}


